import { useSelector } from "react-redux"

import SettingsModule from 'modules/settings'

const useUserChunks = () => {
    const billing = useSelector(SettingsModule.selectors.getBillingInfo)

    return billing['userChunks']
}

export default useUserChunks
